
import { mapGetters } from 'vuex'
export default {
  // eslint-disable-next-line vue/component-definition-name-casing
  name: 'v-custom-addressf',
  // eslint-disable-next-line vue/require-prop-types
  props: ['type', 'value', 'obj'],
  data() {
    return {
      resetMap: null,
      updateMap: null,
      switchCodeOrMap: false,
      location: {
        cp: null,
        lat: null,
        lng: null,
        city: null,
        state: null,
        street: null,
        reference: null,
        neighborhood: null,
        outdoorNumber: null,
        interiorNumber: null,
      },
      rules: [(v) => !!v || this.$t('fieldRequired')],
    }
  },
  computed: {
    ...mapGetters({
      platformLatLng: 'setting/platformLatLng' || [
        16.49847115994006, -76.22896135,
      ],
    }),
    input: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
    labelField() {
      if (this.obj && this.obj.schema) {
        return this.obj.schema.label || this.obj.schema.name
      }
      return ''
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.location = val
          ? { ...val }
          : {
              cp: null,
              lat: null,
              lng: null,
              city: null,
              state: null,
              street: null,
              reference: null,
              neighborhood: null,
              outdoorNumber: null,
              interiorNumber: null,
            }
      }
    },
  },
  mounted() {
    this.switchCodeOrMap = this.value?.switchCodeOrMap || false
    this.resetMap = this.value?.resetMap || null
    this.location = this.value
      ? { ...this.value }
      : {
          cp: null,
          lat: Number(this.platformLatLng[0]),
          lng: Number(this.platformLatLng[1]),
          city: null,
          state: null,
          street: null,
          reference: null,
          neighborhood: null,
          outdoorNumber: null,
          interiorNumber: null,
        }
  },
  methods: {
    save(location) {
      this.$emit('input', location)
    },
    handlerLocation(event) {
      if (event) {
        this.location = {
          cp: event.cp,
          lat: event.lat,
          lng: event.lng,
          city: event.city,
          state: event.state,
          street: event.street,
          reference: event.reference,
          neighborhood: event.neighborhood,
          outdoorNumber: event.outdoorNumber,
          interiorNumber: event.interiorNumber,
        }
        this.save(this.location)
      } else {
        this.save(null)
      }
    },
    cleanData() {
      this.location = {
        cp: null,
        lat: null,
        lng: null,
        city: null,
        state: null,
        street: null,
        reference: null,
        neighborhood: null,
        outdoorNumber: null,
        interiorNumber: null,
      }
      this.resetMap = !this.resetMap
    },
  },
}
